<div class="tp-page tp-page--compact factor-container">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Factores"
    [subtitle]="factors.length + (factors.length === 1 ? ' factor' : ' factores')">
    <button mat-flat-button actions id="addButton" type="button" (click)="openModal()">
      <mat-icon>add</mat-icon>
      Agregar factor
    </button>
    </tp-page-header>
    <ul class="sa-list">
      @for (factor of factors; track factor) {
        <li class="sa-item">
          <div class="sa-item__body">
            <p class="sa-item__title">{{ factor.name }}</p>
            <p class="sa-item__meta">
              <span>Peso: {{ factor.weight }}</span>
              <span>Puntos: {{ factor.points }}</span>
            </p>
          </div>
          <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
          <mat-menu #menu="matMenu">
            <button id="editButton" mat-menu-item (click)="openModal(factor)">
              Editar
            </button>
            <button
              id="deleteButton"
              mat-menu-item
              (click)="deleteFactor(factor.id)"
            >
              Eliminar
            </button>
          </mat-menu>
        </li>
      } @empty {
        <li>
          <tp-empty-state
            icon="tune"
            title="Todavía no hay factores"
            message="Agregá el primer factor con el botón de arriba."
          ></tp-empty-state>
        </li>
      }
    </ul>
  </section>

  <!-- Panel de alta / edición de factor -->
  <div
    class="factor-modal-container d-flex align-items-center justify-content-center w-100"
    [ngClass]="{ expanded: showFactorModal }"
  >
    @if (showFactorModal) {
      <div class="backButton">
        <mat-icon (click)="backToScore()"> keyboard_arrow_left </mat-icon>
      </div>
    }
    @if (showFactorModal) {
      <div class="modal-container w-100">
        <app-factor-modal
          [selectedFactor]="selectedFactor"
          (closeModal)="backToScore()"
          (reloadPage)="ngOnInit()"
        ></app-factor-modal>
      </div>
    }
  </div>
</div>
